module.exports = __webpack_public_path__ + "img/whatsapp.08a21c8f.png";